import {defineStore} from 'pinia';
import {AuthStore, BaseAuthUser, setupAuthStore} from "@codeages-private/qingjs-vue-skeleton-base";

export interface AppAuthUser extends BaseAuthUser {
    ip: string;
    schoolId: number;
}

export const useAuthStore = defineStore<string, AuthStore<AppAuthUser>>('app', () => {
    return setupAuthStore<AppAuthUser>('app', {
        id: "",
        nickname: "",
        roles: [],
        avatar: "",
        token: "",
        ip: "",
        schoolId: 0,
    });
});

